module.exports = __webpack_public_path__ + "img/VADER-sample.0548e4e2.gif";